import React from "react";
import WithAuth from "../../hoc/WithAuth";
import AgronomyTable from "../../components/tables/admin/AgronomyTable";
import { Button } from "antd";
import { AntCloudOutlined } from "@ant-design/icons";

function AgronomyPage() {
  return (
    <div className="mt-[25px] px-[50px] pt-[22px] bg-white">
      <AgronomyTable />
    </div>
  );
}

export default WithAuth(AgronomyPage);
